export enum OccurrenceType {
    EVERY = 0,
    EVERYWEEKDAY = 1,
    DAYOFMONTH = 2,
    WEEKDAYOFMONTH = 3,
    MONTHDATE = 4
}